import {
  DocumentTypeEnumType,
} from 'features/declaration/models/schemas/documentSchemas'

export type DocumentFile = {
  id: number
  fileName: string
  documentId: number
  mimeType: string
  sequenceNumber:number
  deleted: false
  uuid: string
  file: null
  fileBlob: null
  url: null
}

type DocumentBase = {
  id: number
  type: DocumentTypeEnumType
  sequenceNumber: number
  documentType: string
  referenceNumber: string
  deleted: boolean
  files: DocumentFile[]
}

export type TransportDocument = DocumentBase & {
  type: 'TRANSPORT'
}

export type PreviousDocument = DocumentBase & {
  type: 'PREVIOUS'
  complementOfInformation: string
  transportDocumentReferenceNumber: string
  procedureType: string | null
}

export type SupportingDocument = DocumentBase & {
  type: 'SUPPORTING'
  complementOfInformation: string
  documentLineNumber: number | null
}

export type NoteDocument = DocumentBase & {
  type: 'NOTE'
  complementOfInformation: string
  transitOperationId: number | null
}

export type Document = TransportDocument | PreviousDocument | SupportingDocument | NoteDocument

export const isTransportDocument = (d: Document): d is TransportDocument => d.type === 'TRANSPORT'
export const isPreviousDocument = (d: Document): d is PreviousDocument => d.type === 'PREVIOUS'
export const isSupportingDocument = (d: Document): d is SupportingDocument => d.type === 'SUPPORTING'
